module.exports = __webpack_public_path__ + "static/kristy_salmon-9bd4261cfe0f4a913786521408df46b5.jpg";